import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '../views/index.vue'
import classification from '../views/classification.vue'
import list from '../views/list.vue'

import health from './modules/health'
import register from './modules/register'
import pay from './modules/pay'
import medicine from './modules/medicine'
import consultation from './modules/consultation'
import query from './modules/query'
import activation from './modules/activation'
import insurance from './modules/insurance'
import apply from './modules/apply'

import society from './modules/society'
import societyApply from './modules/societyApply'
import societyAuthentication from './modules/societyAuthentication'
import societyRetirement from './modules/societyRetirement'
import societyQuery from './modules/societyQuery'
import societyResident from './modules/societyResident'
import societyTemporary from './modules/societyTemporary'

import life from './modules/life'
import lifeWater from './modules/lifeWater'
import lifeElectricity from './modules/lifeElectricity'
import lifeGas from './modules/lifeGas'
import lifePhone from './modules/lifePhone'
import lifeTelevision from './modules/lifeTelevision'

import traffic from './modules/traffic'
import trafficLine from './modules/trafficLine'
import trafficCar from './modules/trafficCar'
import trafficVote from './modules/trafficVote'
import trafficCode from './modules/trafficCode'
import trafficTrain from "./modules/trafficTrain";
import trafficAircraft from "./modules/trafficAircraft";

import shopping from "./modules/shopping";
import shoppingDish from "./modules/shoppingDish";
import shoppingEat from "./modules/shoppingEat";
import shoppingRefund from "./modules/shoppingRefund";
import shoppingChange from "./modules/shoppingChange";
import shoppingPower from "./modules/shoppingPower";

import end from "./modules/end";

import over from '@/router/modules/over'

// 皖事通
import wstRegister from '@/router/wstModules/register'
import wstActivationMainRoutes from '@/router/wstModules/activation'
import wstPayMainRoutes from '@/router/wstModules/pay'
import wstQueryMainRoutes from '@/router/wstModules/query'
import wstInsuranceMainRoutes from '@/router/wstModules/insurance'
import wstApplyMainRoutes from '@/router/wstModules/apply'

import wxMedicineRoutes from '@/router/comModules/medicine'
import wxConsultationRoutes from '@/router/comModules/consultation'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/classification',
    name: 'classification',
    component: classification
  },
  {
    path: '/list',
    name: 'list',
    component: list
  },
  // 结尾模块
  end,

  // 医疗健康模块
  health,
  register,
  pay,
  medicine,
  consultation,
  query,
  activation,
  insurance,
  apply,

  // 社会保障模块
  society,
  societyApply,
  societyAuthentication,
  societyRetirement,
  societyQuery,
  societyResident,
  societyTemporary,

  // 生活缴费模块
  life,
  lifeWater,
  lifeElectricity,
  lifeGas,
  lifePhone,
  lifeTelevision,

  // 交通出行模块
  traffic,
  trafficLine,
  trafficCar,
  trafficVote,
  trafficCode,
  trafficTrain,
  trafficAircraft,

  // 购物消费模块
  shopping,
  shoppingDish,
  shoppingEat,
  shoppingRefund,
  shoppingChange,
  shoppingPower,

  // 皖事通
  wstRegister,
  wstActivationMainRoutes,
  wstPayMainRoutes,
  wstQueryMainRoutes,
  wstInsuranceMainRoutes,
  wstApplyMainRoutes,
  // 结束页面
  over,
  wxMedicineRoutes,
  wxConsultationRoutes,

]

const router = new VueRouter({
  // mode: 'history',
  routes
})


// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


export default router
